import { Component } from "@angular/core";
import { ViewController, NavParams } from "ionic-angular";
import { Topic, TopicItem } from "../../../../app/models/types";
import { AppState } from "../../../../app/models/app.state";
import { Store } from "@ngrx/store";
import { Subscription } from "rxjs/Subscription";
import { take } from "rxjs/operators";
import { ManualItem } from "../../../../app/models/manual-item";
import { TranslateService } from "@ngx-translate/core";
import { DashboardService } from "../../../../app/services/dashboard.service";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "topic-info-modal",
  templateUrl: "topic-info.modal.html"
})
export class TopicInfoModal {
  topic: Topic = { id: null, i18n: null, topicType: null, freeTextFields: {} };
  topicItems: TopicItem[] = [];
  manualItemSubscription: Subscription;
  manualItem: ManualItem = null;
  constructor(
    public viewCtrl: ViewController,
    private navParams: NavParams,
    private store: Store<AppState>,
    private translate: TranslateService,
    private dashboardService: DashboardService,
    public sanitizer: DomSanitizer
  ) {
    this.topic = this.navParams.get("topic") || {};
    this.topicItems = this.navParams.get("topicItems") || [];

    this.manualItemSubscription = this.store
      .select(state => state.manualItems)
      .pipe(take(1))
      .subscribe(manualItems => {
        const relManualItem = manualItems
          .map(
            item => new ManualItem(item, this.translate, this.dashboardService)
          )
          .find(item =>
            item.isRelevant({
              supportFor: {
                proItems: [],
                patientWishes: [],
                consultationTopics: [],
                scoreIds: [],
                dashboardAreaIds: [this.topic.id]
              }
            })
          );
        this.manualItem = relManualItem !== undefined ? relManualItem : null;
      });
  }
  dismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard.page/topic-card.component/topic-info.modal/topic-info.modal.ts